import {LoggerService} from '@/src/services/logger';
import {BaseRepository} from "@/src/repositories/BaseRepository";
import {JsonClient} from "@/src/network/ws/jsonClient";
import {JsonService} from "@/src/network/jsonService";
import {Faq} from "@/src/entities/faq";
import {LanguageEnum} from "@/src/entities/languageEnum";
import {Review} from "@/src/entities/review";
import {Condition} from "@/src/entities/condition";
import {Lodging} from "@/src/entities/lodging";
import Lodgings from "@/src/app/[locale]/home/components/lodgings";

interface IData {
    retrieveFaqList(language: LanguageEnum): Promise<Faq[]>
    retrieveReviewList(language: LanguageEnum): Promise<Review[]>
}

export class DataRepository extends BaseRepository implements IData {

    private jsonService: JsonService

    public constructor() {
        super()
        this.jsonService = new JsonClient();
        LoggerService.getLogger().debug("create faq<< interactor")
    }

    public async retrieveFaqList(language: LanguageEnum): Promise<Faq[]> {
        if (typeof window !== 'undefined') {
            let jsonFile: string
            switch (language) {
                case LanguageEnum.ENGLISH:
                    jsonFile = "faq_en"
                    break
                case LanguageEnum.ITALIAN:
                    jsonFile = "faq_it"
                    break
            }

            const basePath = `${window.location.protocol}//${window.location.host}`
            const endpoint =`${basePath}/jsons/${jsonFile}.json`
            LoggerService.getLogger().debug(`<<< ENDPOINT: ${endpoint}`)

            const res = await this.jsonService.sendRequest<Faq[]>(endpoint)

            LoggerService.getLogger().debug(`<<< faqs: ${JSON.stringify(res)}`)

            return this.createNewPromise<Faq[]>(res)
        }
        return this.createNewPromise<Faq[]>({})
    }

    public async retrieveReviewList(language: LanguageEnum): Promise<Review[]> {
        if (typeof window !== 'undefined') {
            let jsonFile: string
            switch (language) {
                case LanguageEnum.ENGLISH:
                    jsonFile = "reviews_en"
                    break
                case LanguageEnum.ITALIAN:
                    jsonFile = "reviews_it"
                    break
            }

            const basePath = `${window.location.protocol}//${window.location.host}`
            const endpoint =`${basePath}/jsons/${jsonFile}.json`
            LoggerService.getLogger().debug(`<<< ENDPOINT: ${endpoint}`)

            const res = await this.jsonService.sendRequest<Review[]>(endpoint)

            return this.createNewPromise<Review[]>(res)
        }
        return this.createNewPromise<Review[]>({})
    }

    public async retrieveConditionList(language: LanguageEnum, email: string, phone: string): Promise<Condition[]> {
        if (typeof window !== 'undefined') {
            let jsonFile: string
            switch (language) {
                case LanguageEnum.ENGLISH:
                    jsonFile = "termsandconditions_en"
                    break
                case LanguageEnum.ITALIAN:
                    jsonFile = "termsandconditions_it"
                    break
            }

            const basePath = `${window.location.protocol}//${window.location.host}`
            const endpoint =`${basePath}/jsons/${jsonFile}.json`
            LoggerService.getLogger().debug(`<<< ENDPOINT: ${endpoint}`)

            const res = await this.jsonService.sendRequest<Condition[]>(endpoint)
            if (res.response?.data !== undefined) {
                res.response.data = res.response.data.map(value => {
                    const formattedRules = value.rules.map(rule => {
                        let formattedRule = ""
                        formattedRule = rule.replaceAll("<PARAM_EMAIL>", email).replaceAll("<PARAM_PHONE_NUMBER>", phone)
                        return formattedRule
                    })
                    const formattedCondition: Condition = {
                        id: value.id,
                        title: value.title,
                        rules: formattedRules
                    }
                    return formattedCondition
                })
            }

            return this.createNewPromise<Condition[]>(res)
        }
        return this.createNewPromise<Condition[]>({})
    }

    public async retrieveLodgingList(language: LanguageEnum): Promise<Lodging[]> {
        if (typeof window !== 'undefined') {
            let jsonFile: string
            switch (language) {
                case LanguageEnum.ENGLISH:
                    jsonFile = "lodgings_en"
                    break
                case LanguageEnum.ITALIAN:
                    jsonFile = "lodgings_it"
                    break
            }

            const basePath = `${window.location.protocol}//${window.location.host}`
            const endpoint =`${basePath}/jsons/${jsonFile}.json`
            LoggerService.getLogger().debug(`<<< ENDPOINT: ${endpoint}`)

            const res = await this.jsonService.sendRequest<Lodging[]>(endpoint)

            return this.createNewPromise<Lodging[]>(res)
        }
        return this.createNewPromise<Lodging[]>({})
    }
}